<template>
  <cx-showcase-section :name="name" :link="link" class="cx-checkbox-showcase">
    <div class="cxu-d-flex cxu-gap-30">
      <cx-toggle-switch :checked="checked" :onToggle="handleToggle" :label="switchLabel"></cx-toggle-switch>
      <cx-toggle-switch :disabled="true" :checked="false" label="Disabled Off"></cx-toggle-switch>
      <cx-toggle-switch :disabled="true" :checked="true" label="Disabled On"></cx-toggle-switch>
    </div>
  </cx-showcase-section>
</template>

<script>
import CxShowcaseSection from '../CxShowcaseSection';
import CxToggleSwitch from '@/components/CxToggleSwitch';

export default {
  name: 'CxToggleShowcase',
  components: {
    CxShowcaseSection,
    CxToggleSwitch,
  },
  data() {
    return {
      name: 'CxToggleSwitch',
      link: '',
      checked: false
    };
  },
  computed: {
    switchLabel() {
      return this.checked ? 'On' : 'Off';
    }
  },
  methods: {
    handleToggle() {
      this.checked = !this.checked;
    }
  },
};

</script>

<style lang="less">
@import '../../../common';

</style>